import React, { FC, ReactNode, useRef, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import { useToast } from '@shared/lib/toast'
import { suggestionFormValidation } from '../config/suggestionFormValidation'
import { initialSuggestionFormValues } from '../config/initialSuggestionFormValues'
import { SuggestionFormValues } from '../model/suggest.types'

const SUGGESTION_SUBMIT_ERROR = 'Ошибка в отправке данных. Попробуйте позже'

interface SuggestionResponse {
  status: string
  message?: string
}

interface ContentProps {
  isSuggestionSent: boolean
}

interface SuggestionFormProps {
  renderContent: (props: ContentProps) => ReactNode
}

const SuggestionForm: FC<SuggestionFormProps> = ({ renderContent }) => {
  const [isSuggestionSent, setIsSuggestionSent] = useState<boolean>(false)

  const suggestionFormRef = useRef<FormikProps<SuggestionFormValues>>(null)

  const { toast } = useToast()

  const handleSuggestionFormSubmit = (values: SuggestionFormValues) =>
    fetch(
      'https://script.google.com/macros/s/AKfycbynlHUfP3mqoOAoIp1exmYtV0c-rs_dprg6GOPFwVm2EvhW_TX-BoT1bc0QJvxggMO2XQ/exec',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        body: JSON.stringify({
          suggestion: values.suggestion,
        }),
        redirect: 'follow',
      }
    )
      .then((response) => response.json())
      .then((data: SuggestionResponse) => {
        if (data.status === 'success') {
          setIsSuggestionSent(true)

          return
        }

        toast({ variant: 'error', description: data.message || SUGGESTION_SUBMIT_ERROR })
      })
      .catch(() => {
        toast({ variant: 'error', description: SUGGESTION_SUBMIT_ERROR })
      })

  return (
    <Formik
      enableReinitialize
      validateOnChange
      innerRef={suggestionFormRef}
      initialValues={initialSuggestionFormValues}
      validationSchema={suggestionFormValidation}
      onSubmit={handleSuggestionFormSubmit}
    >
      <Form>{renderContent({ isSuggestionSent })}</Form>
    </Formik>
  )
}

export default SuggestionForm
